import React from "react"
import {withRouter} from "react-router-dom"
import UserAvatar from "./photograher_avatar"


class PhotographerItem extends React.Component {
  render() {
    let photographer = this.props.photographer
    const currentUser = this.props.currentUser
    const showAvailability = this.props.onAvailability &&
      !currentUser?.roles?.contractor &&
      !currentUser?.roles?.post_production &&
      currentUser?.id !== photographer.id

    const isAdmin = currentUser?.roles?.admin || currentUser?.super_admin
    const profileHref = `/photographers/${photographer.id}?from=directory`
    const handleProfileClick = isAdmin ? (e) => {
      e.preventDefault()
      this.props.history.push(profileHref)
    } : undefined

    return (
      <div className="photographerCard">
        <div className="photographerCardHeader" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div className="photographerCardGrouping">
            <UserAvatar user={photographer}/>
            <div className="photographerCardInfo">
              <div className="photographerCardName">{photographer.firstName} {photographer.lastName[0]}</div>
              <div className="photographerMainInfo">
                <a className="photographerCardButton" href={profileHref} target={isAdmin ? undefined : "_blank"} onClick={handleProfileClick}>
                  <i className="far fa-user-circle"/>
                  Profile
                </a>
              </div>
            </div>
          </div>
          {showAvailability && (
            <button style={{ marginLeft: 'auto', flexShrink: 0, cursor: 'pointer', padding: '7px 16px', color: '#FFFFFF', background: '#1B264F', borderRadius: '5px', fontWeight: 600, fontSize: '12px', border: 'none' }} onClick={this.props.onAvailability}>
              Availability
            </button>
          )}
          <div className="photographerMainInfoMobile">
            <a className="photographerCardButton" href={profileHref} target={isAdmin ? undefined : "_blank"} onClick={handleProfileClick}>
              <i className="far fa-user-circle"/>
              Profile
            </a>
          </div>
        </div>
        <div className="photographerCardBody">
        </div>
      </div>
    )
  }
}

export default withRouter(PhotographerItem)
